import { Card, CardContent } from '@/components/ui/Card';

interface MetricCardProps {
  title: string;
  value: React.ReactNode;
  subtitle?: string;
  icon: React.ReactNode;
}

export function MetricCard({ title, value, subtitle, icon }: MetricCardProps) {
  return (
    <Card className="transition-shadow hover:shadow-md">
      <CardContent className="p-6">
        <div className="flex justify-between pb-2">
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
        </div>
        <div className="flex items-center justify-between">
          <div>
            <p
              className="max-w-[200px] truncate text-2xl font-bold"
              title={value as string}
            >
              {value}
            </p>
            {subtitle && (
              <p className="text-xs text-muted-foreground">{subtitle}</p>
            )}
          </div>
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
